import Button from '@/features/shared/Button';
import Image from '@/features/shared/Image';
import {
  MuiBox,
  MuiButtonBase,
  MuiCard,
  MuiCardActions,
  MuiCardContent,
  MuiTypography,
} from '@/features/shared/material-ui';
import RichText, { CaptureClicksRichText } from '@/features/shared/RichText';
import { getPageUrl, mapLinkToProps } from '@/utils/helpers';
import { BrPageContext } from '@bloomreach/react-sdk';
import clsx from 'clsx';
import React, { memo } from 'react';
import useStyles from './CustomerCard.styles';

const CustomerCard = ({
  cardDescription,
  cardHeading,
  cardCategory,
  cardColor,
  theme,
  cardTheme,
  cardLogo,
  customerStoryCardInfo,
  buttonLink,
  categoryOnTop = false,
  className: overrideClassName,
  url = '',
}: any) => {
  const classes = useStyles({});
  const cardClassName = clsx(
    classes.card,
    classes.bgCard,
    `${theme}-theme`,
    `bg-color-${cardColor}`,
    overrideClassName,
    'gtm-headline-container',
  );
  const page = React.useContext(BrPageContext);
  const cardHref = page && getPageUrl({ url, page });
  const cardLinkProps = mapLinkToProps({ href: cardHref });
  const hasCardUrl = !!url;

  return (
    <MuiCard className={`${cardClassName}`} elevation={8}>
      <MuiCardContent className={classes.cardContent}>
        {categoryOnTop && cardCategory && (
          <MuiTypography
            variant="overline"
            component="div"
            className={clsx(classes.category, classes.categoryTop)}
          >
            {cardCategory?.label || cardCategory}
          </MuiTypography>
        )}
        {cardLogo && (
          <div className={classes.cardLogo}>
            <Image
              key={cardLogo?.original?.url}
              image={{ ...cardLogo, fullWidthImage: false }}
              base="original"
              size="contain"
              position="left"
              roundedCorners={false}
            />
          </div>
        )}
        {!categoryOnTop && cardCategory && (
          <MuiTypography variant="overline" component="div" className={classes.category}>
            {cardCategory?.label || cardCategory}
          </MuiTypography>
        )}
        {cardHeading && (
          <MuiTypography
            className={clsx(classes.cardHeading, 'gtm-headline')}
            variant="h6"
            dangerouslySetInnerHTML={{ __html: cardHeading }}
          />
        )}
        {cardDescription && (
          <CaptureClicksRichText
            theme={cardTheme}
            containerProps={{ className: classes.cardDescription }}
            content={cardDescription}
          />
        )}

        {(buttonLink?.displayText || customerStoryCardInfo) && (
          <MuiCardActions className={classes.cardActions}>
            <MuiBox display="flex" justifyContent="space-between" className="box">
              {customerStoryCardInfo && (
                <div className={classes.cardActionsCol}>
                  <RichText
                    content={customerStoryCardInfo}
                    theme={cardTheme}
                    className={classes.cardInfo}
                  />
                </div>
              )}
              {buttonLink?.displayText && (
                <div className={clsx(classes.cardActionsCol, classes.cardCta)}>
                  <Button
                    link={buttonLink}
                    theme={cardTheme}
                    className={clsx(classes.cardActionsLink, 'gtm-featured-content-cta')}
                  />
                </div>
              )}
            </MuiBox>
          </MuiCardActions>
        )}
      </MuiCardContent>
      {hasCardUrl && (
        <MuiButtonBase
          {...cardLinkProps}
          className={clsx(classes.cardLink, 'gtm-featured-content-cta')}
        />
      )}
    </MuiCard>
  );
};

export default memo(CustomerCard);
